import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FolderIcon from "@mui/icons-material/Folder";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Rating,
  Select,
} from "@mui/material";
import { toUpper } from "lodash";
import { useNavigate } from "react-router-dom";
import IssuesStatusChart from "./IssuesStatusChart";
import moment from "moment";

const dummyTopics = [
  {
    id: 1,
    user: "",
    title: "The picture is not displaying properly",
    feedback: "The Yi Home Mobile app is unable to pair with the camera",
    isAdmin: false,
  },
  {
    id: 2,
    user: "",
    title: "Unable to display video",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 3,
    user: "",
    title: "The images are not playing in my video",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
];

const Demo = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

export default function ChatIssuesStatusChart(props: any) {
  const {
    Topfivetickets,
    ReportsTicketsTopfiveCount,
    ReportsTicketsTotalCountsData,
    ReportsTicketsRaisedData,
    startDateValue,
    endDateValue,
  } = props;

  const [dense, setDense] = React.useState(false);
  const [secondary, setSecondary] = React.useState(false);
  const [filtertype, setFiltertype] = React.useState("weekly");

  const navigate = useNavigate();

  const handleRedirectUncategorisedTickets = () => {
    // navigate("/tickets");
    const stateObj = {
      pageType: "mainReportPage",
    };
    navigate(`/view-uncategorized-ticket`, { state: stateObj });
  };
  const handleInputChange = (value: any) => {
    setFiltertype(value);
  };
  return (
    <Grid
      item
      sx={{ border: "1px solid #ccc", borderRadius: "8px", overflow: "hidden" }}
    >
      <Typography className="repu-heading">
        <Typography
          sx={{ fontWeight: 700, fontSize: "13px", textTransform: "uppercase" }}
        >
          Issue Resolution Metrics{" "}
          {/* <Avatar
            sx={{
              height: "35px",
              width: "35px",
              marginLeft: "5px",
              fontSize: "10px",
              background: "#2858D3",
              display: "inline-flex",
              border: "1px solid #FFF",
            }}
          >
            {ReportsTicketsTopfiveCount}
          </Avatar> */}
        </Typography>
        <FormControl className="custom-select gudieTourPlatform">
          <Select
            sx={{
              boxShadow: "none",
              ".MuiOutlinedInput-notchedOutline": { border: 0 },
              "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                {
                  border: 0,
                },
              "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                {
                  border: 0,
                },
            }}
            labelId="platform-select"
            id="platform-select"
            value={filtertype}
            label="platform"
            onChange={(e) => handleInputChange(e.target.value)}
          >
            <MenuItem key={1} value={"daily"}>
              {"Daily"}
            </MenuItem>
            <MenuItem key={2} value={"weekly"}>
              {"Weekly"}
            </MenuItem>
            <MenuItem key={3} value={"monthly"}>
              {"Monthly"}
            </MenuItem>
          </Select>
        </FormControl>
      </Typography>
      <IssuesStatusChart
        filtertype={filtertype}
        startDateValue={moment(new Date(startDateValue), "DD-MM-YYYY").format(
          "DD/MM/YYYY"
        )}
        endDateValue={moment(new Date(endDateValue), "DD-MM-YYYY").format(
          "DD/MM/YYYY"
        )}
        ReportsTicketsTotalCountsData={ReportsTicketsTotalCountsData}
        ReportsTicketsRaisedData={ReportsTicketsRaisedData}
      />
    </Grid>
  );
}
